// 花嫁「破れたバージンロード」(thornAisle・kind 'thorns') の薔薇の茨 (2026-10-10・ユーザー採用 rose-game「このまま配布版へ」で既定は薔薇)。
//
// ユーザー：「床の波は完全に仮で作ってもらったままだから、見本を作るところから。花嫁のバージンロードとかも結構雑に作った床技エフェクトだな」
//   手本＝Hollow Knight／Troupe Master Grimm の外套の棘。モチーフ＝「薔薇の花や薔薇の棘をモチーフにして」。
//   見本の絵＝C:/dev/LUNAIRE-notes/assets/2026-10-10-floor-fx-mihon/floor_fx_bride_rose_v2.png（予告→当たり→しおれる）。
//   記録と動画＝C:/dev/LUNAIRE-notes/assets/2026-10-10-bride-rose-game/README.md
//
// 開発版の切り替え ?thornLook=now|crystal|old で旧の結晶へ戻して見比べる（読むのは下の DEV の箱の中だけ）。指定なし／他の値＝既定の薔薇 (rose)。配布版は常に薔薇。
// 🔴 見た目だけ。当たりの場所・時間・範囲は変えない (hits.ts はこのファイルを読まない)。
//   茨・薔薇は当たりの帯 [xStart, xEnd] の中だけに置く (隙間へはみ出さない・tests/bride_rose_thorns.test.ts)。
//   赤・朱・深紅は使わない (赤＝弾けない攻撃の専用色・docs/taste-baseline.md)。線の効果 (放射線・効果線) は描かない。
//   ⚠️ 識別子に URL のキーの綴りを入れない (scripts/check_dev_leak.mjs が配布ビルドの文字列を見張る)。
//
// 作り：茎・薔薇・つぼみ・花びらは Codex に描かせた部品の絵 (public/sprites/fx/hazard/bride_rose_atlas.png・
//   元の絵と切り出し＝上の README) を、コードで曲げて・伸ばして・回して動かす。茎はまっすぐ描かせた絵を、
//   ベジェ曲線に沿って細い輪切りで並べ直して「獣の角のように反った茎」にする。
//
// 時間の流れ (手本 T1 をコマ送りで見た：22.30〜22.40 床に小さな鉤が並ぶ → 22.45 膝の高さ → 22.55 伸びきる (約 0.15 秒)
//   → 23.0 まで立つ → 23.1 床へ引っ込み 23.3 で消える。4本は同時。ここでは花嫁に近い側から最大 0.1 秒ずらす＝手本 T3)：
//   予告 0〜(溜め−立ち上がり)：割れ目が光り、茎の先とつぼみがすねの高さまでのぞく。終盤は震える。
//   立ち上がり：溜めの最後 RISE_MS で床から突き上がる (近い側から順に)。当たりの開始には伸びきっている。
//   当たり：開始と同時に薔薇が咲き、花びらが舞う。わずかに揺れる。
//   しおれる：当たりが終わった後 WITHER_MS。灰色にくすみ、外へ垂れ、先から崩れて沈む。薔薇は落ち、花びらが散る。

import { sw as swc, swapImage, swTriplet } from './purple_swap'

export type BrideThornMotif = 'crystal' | 'rose'
export function parseBrideThornMotif(v: unknown): BrideThornMotif | null {
  const k = typeof v === 'string' ? v.toLowerCase() : ''
  if (k === 'rose' || k === 'bara') return 'rose'
  if (k === 'crystal' || k === 'now' || k === 'old') return 'crystal'
  return null
}
let motif: BrideThornMotif = 'rose'
export function brideThornMotif(): BrideThornMotif { return motif }
/** テスト用。配布版では URL を読まないので、ここを呼ぶ物はテストだけ。 */
export function setBrideThornMotifForTest(next: BrideThornMotif): void { motif = next }

// ───────── 時間 (ms) ─────────
/** 床から突き上がる時間 (手本 T1 の 22.40→22.55)。 */
export const ROSE_RISE_MS = 150
/** 花嫁から遠い側の遅れの上限 (手本 T3 の「ボス側から順に」)。立ち上がりはこの分だけ早く始まる＝当たりの開始には全部伸びきる。 */
export const ROSE_STAGGER_MS = 100
/** 予告の最初に、つぼみと茎の先がのぞききるまで。 */
export const ROSE_PEEK_IN_MS = 260
/** 当たりの開始に薔薇が開ききるまで。 */
export const ROSE_BLOOM_MS = 180
/** 当たりが終わった後、しおれて消えるまで。 */
export const ROSE_WITHER_MS = 650

// ───────── 大きさ (px・ゲームの座標) ─────────
/** のぞく高さ (主人公のすね)。 */
export const ROSE_PEEK_H = 30
/** 茨の一番高い茎 (主人公の背 約115px の約2倍)。幅 140 以上の場所。 */
export const ROSE_CANE_H_WIDE = 228
/** 幅 140 未満の場所の一番高い茎。 */
export const ROSE_CANE_H_NARROW = 200
/** 帯の端から空ける余白 (揺れの分を含む)。 */
export const ROSE_EDGE_MARGIN = 3

// ───────── 色 (赤・朱・深紅を使わない) ─────────
export const ROSE_COLORS = {
  glowCore: [214, 196, 255] as const,   // 割れ目の光 (淡いすみれ)
  glowOuter: [154, 122, 196] as const,  // 花嫁の灰紫 #9A7AC4
  crack: [22, 12, 32] as const,         // 割れ目の暗がり
  shard: [58, 48, 70] as const,         // 床石のかけら
  shardRim: [154, 122, 196] as const,
  ash: [92, 84, 100] as const,          // 崩れた灰
  witherTint: [96, 88, 104] as const,   // しおれた茎の灰
}

// ───────── 部品の絵 (atlas) ─────────
type Rect = readonly [number, number, number, number]
export const ROSE_ATLAS: Record<string, Rect> = {
  cane_0: [0, 0, 72, 480], cane_1: [74, 0, 71, 480], cane_2: [147, 0, 70, 467],
  rose_0: [219, 0, 136, 130], rose_1: [0, 482, 155, 144], rose_2: [157, 482, 83, 110],
  bud_0: [242, 482, 50, 97], bud_1: [294, 482, 45, 94], wither_0: [341, 482, 120, 134],
  petal_0: [463, 482, 43, 33], petal_1: [0, 628, 47, 41], petal_2: [49, 628, 41, 49], petal_3: [92, 628, 46, 35],
  petal_4: [140, 628, 37, 51], petal_5: [179, 628, 38, 52], petal_6: [219, 628, 43, 40],
}
/** 茎の絵の芯の位置 (横の割合) を、上端 v=0 → 下端 v=1 の2次式で。元の絵で測った (README)。 */
const CANE_AXIS: Record<string, readonly [number, number, number]> = {
  cane_0: [-0.22, 0.321, 0.388], cane_1: [-0.015, 0.119, 0.405], cane_2: [-0.21, 0.386, 0.326],
}
/** 茎の絵の、芯から左右の端 (棘の先) までの距離 ÷ 絵の幅。根元 s=0 から先 s=1 を 16 区切り。元の絵で測った (README)。
 *  はみ出しの計算に使う (隙間へ棘を出さない)。 */
const CANE_EXT: Record<string, { L: readonly number[]; R: readonly number[] }> = {
  cane_0: {
    L: [0.354, 0.457, 0.502, 0.324, 0.463, 0.504, 0.307, 0.427, 0.254, 0.357, 0.403, 0.405, 0.337, 0.433, 0.208, 0.051],
    R: [0.438, 0.474, 0.331, 0.495, 0.231, 0.441, 0.457, 0.448, 0.288, 0.337, 0.472, 0.22, 0.372, 0.109, 0.167, 0.158],
  },
  cane_1: {
    L: [0.309, 0.317, 0.382, 0.432, 0.37, 0.477, 0.33, 0.365, 0.401, 0.183, 0.388, 0.226, 0.205, 0.254, 0.078, 0.099],
    R: [0.353, 0.443, 0.505, 0.356, 0.433, 0.326, 0.403, 0.381, 0.444, 0.451, 0.232, 0.436, 0.218, 0.182, 0.119, 0.028],
  },
  cane_2: {
    L: [0.331, 0.303, 0.431, 0.285, 0.295, 0.46, 0.353, 0.472, 0.389, 0.162, 0.32, 0.204, 0.386, 0.195, 0.232, 0.052],
    R: [0.354, 0.497, 0.284, 0.301, 0.391, 0.225, 0.347, 0.428, 0.282, 0.409, 0.209, 0.353, 0.142, 0.233, 0.097, 0.105],
  },
}
const CANE_NAMES = ['cane_0', 'cane_1', 'cane_2'] as const
const PETAL_NAMES = ['petal_0', 'petal_1', 'petal_2', 'petal_3', 'petal_4', 'petal_5', 'petal_6'] as const

type AtlasImage = CanvasImageSource & { naturalWidth?: number; width?: number }
let atlas: AtlasImage | null = null
let atlasGray: AtlasImage | null = null
let atlasLoading = false
/** 部品の絵の読み込み (薔薇の時だけ)。 */
export function preloadBrideRoseAtlas(src = '/sprites/fx/hazard/bride_rose_atlas.png'): void {
  if (atlas || atlasLoading || typeof Image === 'undefined') return
  atlasLoading = true
  const img = new Image()
  img.onload = () => {
    atlas = img
    atlasGray = makeGrayAtlas(img)
  }
  img.src = src
}
/** テスト用 (偽の絵を差す)。 */
export function setBrideRoseAtlasForTest(img: AtlasImage | null, gray: AtlasImage | null = null): void {
  atlas = img; atlasGray = gray
}
/** しおれた色の絵を1回だけ作る (毎コマ filter をかけない)。 */
function makeGrayAtlas(img: HTMLImageElement): AtlasImage | null {
  if (typeof document === 'undefined') return null
  const c = document.createElement('canvas')
  c.width = img.naturalWidth; c.height = img.naturalHeight
  const g = c.getContext('2d')
  if (!g) return null
  g.filter = 'grayscale(0.85) brightness(0.62) contrast(0.9)'
  g.drawImage(img, 0, 0)
  g.filter = 'none'
  // 灰に花嫁の紫を少しだけ戻す
  g.globalCompositeOperation = 'source-atop'
  g.fillStyle = 'rgba(96,80,118,0.22)'
  g.fillRect(0, 0, c.width, c.height)
  return c
}

// ───────── 乱数 (場所ごとに決まった並び) ─────────
function mulberry32(seed: number): () => number {
  let a = seed >>> 0
  return () => {
    a = (a + 0x6D2B79F5) >>> 0
    let t = a
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
const clamp01 = (v: number) => Math.max(0, Math.min(1, v))
const lerp = (a: number, b: number, t: number) => a + (b - a) * t
const easeOutCubic = (t: number) => 1 - Math.pow(1 - clamp01(t), 3)
const easeInCubic = (t: number) => Math.pow(clamp01(t), 3)
const easeInOut = (t: number) => { const x = clamp01(t); return x * x * (3 - 2 * x) }
/** 突き上がりの勢い (少し行き過ぎて戻る・r=1 でちょうど 1)。 */
export function riseEase(r: number): number {
  const t = clamp01(r)
  const c1 = 1.2, c3 = c1 + 1
  return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2)
}

// ───────── 並び ─────────
export interface RoseCane {
  name: typeof CANE_NAMES[number]
  rootX: number
  /** 根元から先までの高さ */
  h: number
  /** 外へ反る向き (-1 左 / +1 右) */
  dir: number
  /** 反りの大きさ (px) */
  bow: number
  /** 先が内へ戻る量 (px) */
  curl: number
  /** 幅の倍率 */
  widthMul: number
  swayPhase: number
}
export interface RoseBloom {
  /** 茎の番号 (-1 = 床から出る低いつぼみ) */
  cane: number
  /** 茎の上の位置 0..1 (cane>=0 の時) */
  s: number
  /** 床のつぼみの x (cane=-1 の時) */
  x: number
  /** 床のつぼみの高さ (cane=-1 の時) */
  stalkH: number
  /** 咲いた花の幅 (px) */
  size: number
  rose: 'rose_0' | 'rose_1' | 'rose_2'
  bud: 'bud_0' | 'bud_1'
  tilt: number
  /** 茎の横へずらす量 (-1..1・茎の幅の割合) */
  side: number
}
export interface RoseCluster {
  xStart: number
  xEnd: number
  canes: RoseCane[]
  blooms: RoseBloom[]
  seed: number
}

const layoutCache = new Map<string, RoseCluster>()

/** 茎の芯の点 (s=0 根元 → 1 先)。根元の座標から見た相対 (上が負)。droop = しおれて外へ垂れる角度 (rad)。 */
export function canePoint(c: RoseCane, s: number, droop = 0): { x: number; y: number } {
  const t = clamp01(s)
  const p1x = c.dir * c.bow, p1y = -0.36 * c.h
  const p2x = c.dir * c.bow * 1.05, p2y = -0.76 * c.h
  const p3x = c.dir * c.bow * 0.35 - c.dir * c.curl, p3y = -c.h
  const u = 1 - t
  let x = 3 * u * u * t * p1x + 3 * u * t * t * p2x + t * t * t * p3x
  let y = 3 * u * u * t * p1y + 3 * u * t * t * p2y + t * t * t * p3y
  if (droop !== 0) {
    const a = c.dir * droop * Math.pow(t, 1.6)
    const cs = Math.cos(a), sn = Math.sin(a)
    const rx = x * cs - y * sn, ry = x * sn + y * cs
    x = rx; y = ry
  }
  return { x, y }
}
/** 茎の曲線の点と弧の長さ・描く幅 (drawCane と はみ出しの計算で同じ物を使う)。 */
const CANE_SLICES = 34
function caneGeom(c: RoseCane, droop = 0): { pts: { x: number; y: number }[]; seg: number[]; L: number; dw: number } {
  const pts: { x: number; y: number }[] = []
  for (let i = 0; i <= CANE_SLICES; i++) pts.push(canePoint(c, i / CANE_SLICES, droop))
  const seg: number[] = [0]
  for (let i = 1; i <= CANE_SLICES; i++) seg.push(seg[i - 1]! + Math.hypot(pts[i]!.x - pts[i - 1]!.x, pts[i]!.y - pts[i - 1]!.y))
  const L = seg[CANE_SLICES]!
  const rect = ROSE_ATLAS[c.name]!
  const dw = rect[2] * (L / rect[3]) * c.widthMul
  return { pts, seg, L, dw }
}
/** 茎の s での芯の半幅の目安 (割れ目や花の置き場に使う・棘は含まない)。 */
export function caneHalfWidth(c: RoseCane, s: number): number {
  return 0.5 * 0.1 * c.h * c.widthMul * (1 - 0.75 * clamp01(s))
}
/** 茎の横の広がり [最小, 最大] (絶対座標・棘の先まで・揺れは含まない)。 */
export function caneExtentX(c: RoseCane, droop = 0): [number, number] {
  const g = caneGeom(c, droop)
  const ext = CANE_EXT[c.name]!
  let lo = Infinity, hi = -Infinity
  for (let i = 0; i < CANE_SLICES; i++) {
    const a = g.pts[i]!, b = g.pts[i + 1]!
    const ang = Math.atan2(b.x - a.x, -(b.y - a.y))
    const cs = Math.abs(Math.cos(ang))
    const bin = Math.min(15, Math.floor(((i + 0.5) / CANE_SLICES) * 16))
    // 区切りの境で隣の値も見る
    const l = Math.max(ext.L[bin]!, ext.L[Math.max(0, bin - 1)]!, ext.L[Math.min(15, bin + 1)]!)
    const r = Math.max(ext.R[bin]!, ext.R[Math.max(0, bin - 1)]!, ext.R[Math.min(15, bin + 1)]!)
    const sn = Math.abs(Math.sin(ang)) * 2
    for (const p of [a, b]) {
      lo = Math.min(lo, c.rootX + p.x - l * g.dw * cs - sn)
      hi = Math.max(hi, c.rootX + p.x + r * g.dw * cs + sn)
    }
  }
  return [lo, hi]
}
/** 揺れの最大の角度 (rad)。 */
export const ROSE_SWAY_RAD = 0.012

/** 帯1か所の並び (場所が同じなら毎回同じ・4か所で本数・反り・花の位置が違う)。 */
export function roseClusterLayout(xStart: number, xEnd: number): RoseCluster {
  const key = `${Math.round(xStart)}|${Math.round(xEnd)}`
  const hit = layoutCache.get(key)
  if (hit) return hit
  const seed = (Math.round(xStart) * 2654435761 + Math.round(xEnd) * 40503) >>> 0
  const rnd = mulberry32(seed)
  const w = xEnd - xStart
  const wide = w >= 140
  const hMax = wide ? ROSE_CANE_H_WIDE : ROSE_CANE_H_NARROW
  const n = wide ? 3 : 2
  const mirror = rnd() < 0.5
  // 根元は帯の真ん中へ寄せて (同じ割れ目から束で出る)、外へ大きく反らせる＝見本の「獣の角」
  const fr = n === 3 ? [0.38, 0.5, 0.62] : [0.41, 0.59]
  // 高さの並び：場所ごとに一番高い茎を変える
  const hOrders = n === 3 ? [[0.82, 1, 0.74], [1, 0.8, 0.9], [0.76, 0.92, 1]] : [[1, 0.8], [0.84, 1]]
  const hs = hOrders[Math.floor(rnd() * hOrders.length)]!
  const canes: RoseCane[] = []
  for (let i = 0; i < n; i++) {
    const f = fr[i]! + (rnd() - 0.5) * 0.05
    let dir = i === 0 ? -1 : i === n - 1 ? 1 : (rnd() < 0.5 ? -1 : 1)
    if (mirror && n === 3 && i === 1) dir = -dir
    const h = hMax * hs[i]! * (0.96 + rnd() * 0.08)
    canes.push({
      name: CANE_NAMES[(i + Math.floor(rnd() * 3)) % 3]!,
      rootX: xStart + w * f,
      h,
      dir,
      bow: h * (0.24 + rnd() * 0.1) * (i === 1 && n === 3 ? 0.3 : 1),
      curl: h * (0.06 + rnd() * 0.06),
      widthMul: 1.25 + rnd() * 0.2,
      swayPhase: rnd() * Math.PI * 2,
    })
  }
  // 帯の中へ収める：はみ出す茎は反りを弱め、それでも出るなら根元を内へ寄せる
  const lo = xStart + ROSE_EDGE_MARGIN, hi = xEnd - ROSE_EDGE_MARGIN
  for (const c of canes) {
    const swayPad = c.h * Math.sin(ROSE_SWAY_RAD)
    for (let k = 0; k < 80; k++) {
      const [a, b] = caneExtentX(c)
      const outL = lo - (a - swayPad), outR = (b + swayPad) - hi
      if (outL <= 0 && outR <= 0) break
      if (k < 10) { c.bow *= 0.85; c.curl *= 0.85; continue }
      if (outL > 0 && outR > 0) { c.widthMul *= 0.95; continue }
      c.rootX += outL > 0 ? Math.min(3, outL) : -Math.min(3, outR)
    }
  }
  // 花：茎に1輪 (一番高い茎の中ほど) ＋ 床から出るつぼみが1輪 (幅のある場所は、場所によって2輪目)
  const tallest = canes.reduce((bi, c, i, arr) => (c.h > arr[bi]!.h ? i : bi), 0)
  const roses = ['rose_0', 'rose_1', 'rose_2'] as const
  const buds = ['bud_0', 'bud_1'] as const
  const blooms: RoseBloom[] = []
  blooms.push({
    cane: tallest, s: 0.42 + rnd() * 0.16, x: 0, stalkH: 0,
    size: (wide ? 50 : 42) * (0.94 + rnd() * 0.12),
    rose: rnd() < 0.5 ? 'rose_1' : 'rose_0', bud: buds[Math.floor(rnd() * 2)]!,
    tilt: (rnd() - 0.5) * 0.5, side: (rnd() < 0.5 ? -1 : 1) * (0.4 + rnd() * 0.3),
  })
  const lowCount = wide && rnd() < 0.6 ? 2 : 1
  for (let j = 0; j < lowCount; j++) {
    const size = (wide ? 30 : 26) * (0.9 + rnd() * 0.2)
    const half = size * 0.5 + ROSE_EDGE_MARGIN + 1
    const gx = lerp(xStart + half, xEnd - half, lowCount === 1 ? 0.25 + rnd() * 0.5 : (j === 0 ? 0.12 + rnd() * 0.2 : 0.68 + rnd() * 0.2))
    blooms.push({
      cane: -1, s: 0, x: gx, stalkH: 18 + rnd() * 16, size,
      rose: roses[Math.floor(rnd() * 3)]!, bud: buds[Math.floor(rnd() * 2)]!,
      tilt: (rnd() - 0.5) * 0.6, side: 0,
    })
  }
  const cl: RoseCluster = { xStart, xEnd, canes, blooms, seed }
  layoutCache.set(key, cl)
  return cl
}

// ───────── 時間の割り振り ─────────
let lastBossX: number | null = null
/** 花嫁の位置 (立ち上がりの順番だけに使う)。render.ts の drawHazards の頭で毎コマ渡す。 */
export function setBrideRoseBossX(x: number | null | undefined): void {
  lastBossX = typeof x === 'number' && Number.isFinite(x) ? x : null
}
/** この場所の立ち上がりの遅れ (ms)。花嫁に近い側ほど早い。 */
export function roseRiseDelayMs(xStart: number, xEnd: number, bossX: number | null = lastBossX): number {
  if (bossX === null) return 0
  const cx = (xStart + xEnd) / 2
  return ROSE_STAGGER_MS * clamp01(Math.abs(cx - bossX) / 720)
}

export interface RoseFrame {
  /** 床から出ている割合 (0 = 埋まっている / peek / 1 = 伸びきり・行き過ぎで 1 を少し超える) */
  emerge: number
  /** のぞく段階の割合 0..1 */
  peek: number
  /** 咲き具合 0..1 */
  bloom: number
  /** 割れ目の光 0..1 */
  glow: number
  /** 予告の終盤の震え (px) */
  tremble: number
  /** 当たりの開始からの ms (当たり前は負) */
  activeMs: number
}

/** 帯1か所のいまの段階。elapsedMs = 帯の経過 (溜めを含む)。 */
export function roseFrame(elapsedMs: number, telegraphMs: number, delayMs: number, nowMs: number): RoseFrame {
  const riseStart = telegraphMs - ROSE_RISE_MS - delayMs
  const peek = easeOutCubic(elapsedMs / ROSE_PEEK_IN_MS)
  const prog = elapsedMs / telegraphMs
  // のぞく段階は peek で描く。emerge は立ち上がりから。
  const emerge = elapsedMs < riseStart ? 0 : riseEase((elapsedMs - riseStart) / ROSE_RISE_MS)
  const activeMs = elapsedMs - telegraphMs
  const bloom = activeMs < 0 ? 0 : easeOutCubic(activeMs / ROSE_BLOOM_MS)
  const late = clamp01((prog - 0.6) / 0.4)
  const pulse = 0.5 + 0.5 * Math.sin(nowMs / 1000 * 14)
  const glow = activeMs < 0
    ? clamp01(0.35 + 0.45 * peek + 0.2 * late * pulse)
    : clamp01(1 - activeMs / 500) * 0.6 + 0.25
  const tremble = activeMs < 0 && elapsedMs < riseStart ? late * 1.2 * Math.sin(nowMs / 1000 * 47) : 0
  return { emerge, peek, bloom, glow, tremble, activeMs }
}

// ───────── 描く ─────────
type RoseCtx = CanvasRenderingContext2D

/** 茎1本を、まっすぐの絵を曲線に沿った輪切りで並べて描く。
 *  lift = 床から持ち上がった量 (px・h で全部出る)、smax = 先から崩れて残る割合、droop = 垂れ、sway = 揺れ (rad)。 */
function drawCane(ctx: RoseCtx, img: AtlasImage, c: RoseCane, floorY: number, lift: number, alpha: number,
  opts: { smax?: number; droop?: number; sway?: number; sink?: number; widthScale?: number } = {}): void {
  const rect = ROSE_ATLAS[c.name]!
  const axis = CANE_AXIS[c.name]!
  const smax = opts.smax ?? 1
  const droop = opts.droop ?? 0
  const sway = opts.sway ?? 0
  const N = CANE_SLICES
  // 弧の長さの表 (絵の縦を弧の長さに合わせて伸ばす)
  const g = caneGeom(c, droop)
  const pts = g.pts, seg = g.seg
  const dw = g.dw * (opts.widthScale ?? 1)
  // 床から出ている分だけ見せる：根元を (h - lift) 沈める
  const sinkY = (c.h - lift) + (opts.sink ?? 0)
  ctx.save()
  ctx.globalAlpha = alpha
  ctx.beginPath()
  ctx.rect(c.rootX - c.h, floorY - c.h * 1.4, c.h * 2, c.h * 1.4 + 3)   // 床より下は描かない
  ctx.clip()
  ctx.translate(c.rootX, floorY + 4 + sinkY)
  if (sway !== 0) ctx.rotate(sway)
  for (let i = 0; i < N; i++) {
    const s0 = i / N, s1 = (i + 1) / N
    if (s0 >= smax) break
    const sEnd = Math.min(s1, smax)
    const a = pts[i]!, b = pts[i + 1]!
    const ang = Math.atan2(b.x - a.x, -(b.y - a.y))
    const len = (seg[i + 1]! - seg[i]!) * ((sEnd - s0) / (s1 - s0))
    // 絵の縦：下端 v=1 が根元、上端 v=0 が先
    const v0 = 1 - s0, v1 = 1 - sEnd
    const sy = rect[1] + rect[3] * v1
    const sh = rect[3] * (v0 - v1)
    const vm = (v0 + v1) / 2
    const axX = (axis[0] * vm * vm + axis[1] * vm + axis[2]) * rect[2]
    ctx.save()
    ctx.translate(a.x, a.y)
    ctx.rotate(ang)
    // 継ぎ目が割れないよう 0.6px 重ねる
    ctx.drawImage(img, rect[0], sy, rect[2], Math.max(0.5, sh),
      -axX * (dw / rect[2]), -len - 0.6, dw, len + 1.2)
    ctx.restore()
  }
  ctx.restore()
}

function drawPart(ctx: RoseCtx, img: AtlasImage, name: string, x: number, y: number, width: number, rot: number,
  alpha: number, anchorY = 0.5): void {
  const r = ROSE_ATLAS[name]!
  const h = width * r[3] / r[2]
  ctx.save()
  ctx.globalAlpha = alpha
  ctx.translate(x, y)
  if (rot) ctx.rotate(rot)
  ctx.drawImage(img, r[0], r[1], r[2], r[3], -width / 2, -h * anchorY, width, h)
  ctx.restore()
}

// 紫の技を替える比較版 (DEV ?purpleSwap・src/purple_swap.ts): 弾けない技なので 'unparry' の色へ写す。案が無い時は c そのまま。
const rgba = (c0: readonly [number, number, number], a: number) => {
  const c = swTriplet('unparry', c0)
  return `rgba(${c[0]},${c[1]},${c[2]},${a.toFixed(3)})`
}

/** 床の割れ目と光 (帯の中だけ)。 */
function drawCrackGlow(ctx: RoseCtx, cl: RoseCluster, floorY: number, glow: number, open: number): void {
  const w = cl.xEnd - cl.xStart
  ctx.save()
  ctx.beginPath()
  ctx.rect(cl.xStart, floorY - 60, w, 80)
  ctx.clip()
  // 割れ目 (床の面に沿った暗い裂け目・根元ごと)
  const rnd = mulberry32(cl.seed ^ 0x5bd1e995)
  ctx.fillStyle = rgba(ROSE_COLORS.crack, 0.85 * open)
  for (const c of cl.canes) {
    const hw = caneHalfWidth(c, 0) * (0.9 + rnd() * 0.3) * open
    ctx.beginPath()
    ctx.moveTo(c.rootX - hw * 1.4, floorY + 1)
    ctx.lineTo(c.rootX - hw * 0.5, floorY - 1.5)
    ctx.lineTo(c.rootX + hw * 0.2, floorY - 0.5)
    ctx.lineTo(c.rootX + hw * 1.3, floorY + 1.5)
    ctx.lineTo(c.rootX + hw * 0.6, floorY + 5)
    ctx.lineTo(c.rootX - hw * 0.7, floorY + 4)
    ctx.closePath()
    ctx.fill()
  }
  // 光 (根元だけ・加算)
  ctx.globalCompositeOperation = 'lighter'
  for (const c of cl.canes) {
    const r = Math.max(10, caneHalfWidth(c, 0) * 2.4)
    const g = ctx.createRadialGradient(c.rootX, floorY, 0, c.rootX, floorY, r)
    g.addColorStop(0, rgba(ROSE_COLORS.glowCore, 0.55 * glow))
    g.addColorStop(0.45, rgba(ROSE_COLORS.glowOuter, 0.28 * glow))
    g.addColorStop(1, rgba(ROSE_COLORS.glowOuter, 0))
    ctx.fillStyle = g
    ctx.save()
    ctx.translate(c.rootX, floorY)
    ctx.scale(1, 0.42)
    ctx.translate(-c.rootX, -floorY)
    ctx.beginPath()
    ctx.arc(c.rootX, floorY, r, 0, Math.PI * 2)
    ctx.fill()
    ctx.restore()
  }
  ctx.restore()
}

/** 床石のかけら (突き上がった瞬間に跳ねて落ちる)。t = 立ち上がりからの ms。 */
function drawShards(ctx: RoseCtx, cl: RoseCluster, floorY: number, t: number): void {
  if (t < 0 || t > 520) return
  const rnd = mulberry32(cl.seed ^ 0x27d4eb2f)
  const sec = t / 1000
  for (const c of cl.canes) {
    for (let j = 0; j < 2; j++) {
      const vx = (rnd() - 0.5) * 90, vy = -(110 + rnd() * 90)
      const size = 2.2 + rnd() * 2.4
      const spin = (rnd() - 0.5) * 14
      let x = c.rootX + vx * sec
      const y = Math.min(floorY + 1, floorY - 2 + vy * sec + 0.5 * 900 * sec * sec)
      x = Math.max(cl.xStart + size, Math.min(cl.xEnd - size, x))
      const a = clamp01(1 - (t - 300) / 220)
      ctx.save()
      ctx.translate(x, y)
      ctx.rotate(spin * sec)
      ctx.globalAlpha = a
      ctx.fillStyle = rgba(ROSE_COLORS.shard, 1)
      ctx.beginPath()
      ctx.moveTo(-size, -size * 0.4); ctx.lineTo(size * 0.2, -size); ctx.lineTo(size, size * 0.3); ctx.lineTo(-size * 0.3, size * 0.8)
      ctx.closePath(); ctx.fill()
      ctx.fillStyle = rgba(ROSE_COLORS.shardRim, 0.8)
      ctx.beginPath()
      ctx.moveTo(-size, -size * 0.4); ctx.lineTo(size * 0.2, -size); ctx.lineTo(size * 0.1, -size * 0.55)
      ctx.closePath(); ctx.fill()
      ctx.restore()
    }
  }
}

/** 花の場所 (茎に付いた花は茎と一緒に動く)。 */
function bloomAnchor(cl: RoseCluster, b: RoseBloom, floorY: number, lift: (c: RoseCane) => number, sway: (c: RoseCane) => number,
  droop = 0, sink = 0): { x: number; y: number; rot: number } {
  if (b.cane < 0) return { x: b.x, y: floorY - b.stalkH + sink, rot: b.tilt }
  const c = cl.canes[b.cane]!
  const p = canePoint(c, b.s, droop)
  const hw = caneHalfWidth(c, b.s)
  const sw = sway(c)
  let x = p.x + b.side * hw * 0.6
  let y = p.y
  const cs = Math.cos(sw), sn = Math.sin(sw)
  const rx = x * cs - y * sn, ry = x * sn + y * cs
  x = c.rootX + rx
  y = floorY + 4 + (c.h - lift(c)) + ry + sink
  const half = b.size * 0.5 + ROSE_EDGE_MARGIN
  x = Math.max(cl.xStart + half, Math.min(cl.xEnd - half, x))
  return { x, y, rot: b.tilt + sw }
}

/** 花びら (咲いた瞬間に散って、ゆっくり落ちる)。t = 当たりの開始からの ms。帯の中へ留める。 */
function drawPetals(ctx: RoseCtx, img: AtlasImage, cl: RoseCluster, floorY: number, t: number,
  anchors: { x: number; y: number }[], alpha: number, burst = 0): void {
  if (t < 0) return
  const rnd = mulberry32(cl.seed ^ (0x9e3779b9 + burst))
  const sec = t / 1000
  for (let i = 0; i < anchors.length; i++) {
    const an = anchors[i]!
    const count = 3
    for (let j = 0; j < count; j++) {
      const name = PETAL_NAMES[Math.floor(rnd() * PETAL_NAMES.length)]!
      const vx = (rnd() - 0.5) * 70
      const vy = -(30 + rnd() * 50)
      const size = 7 + rnd() * 4
      const flutter = 6 + rnd() * 6
      const ph = rnd() * 6.28
      const g = 70
      let x = an.x + vx * sec * (1 / (1 + sec)) + Math.sin(ph + sec * 5) * flutter * clamp01(sec * 3)
      let y = an.y + vy * sec + 0.5 * g * sec * sec
      y = Math.min(floorY - 1, y)
      const half = size * 0.6 + ROSE_EDGE_MARGIN
      x = Math.max(cl.xStart + half, Math.min(cl.xEnd - half, x))
      const landed = y >= floorY - 1
      const rot = ph + (landed ? 0 : sec * (2 + rnd() * 3))
      drawPart(ctx, img, name, x, y, size, rot, alpha * (landed ? 0.7 : 1))
    }
  }
}

/**
 * 帯1か所を薔薇の茨で描く (溜め・当たりの両方)。部品の絵が未読込みなら false (呼び元が今の結晶で描く)。
 *   render.ts の drawHazards が bride_thorn_rise.ts の drawThornAisle 経由で呼ぶ。
 */
export function drawRoseAisle(ctx: RoseCtx, hz: { elapsedMs: number; telegraphMs: number; activeMs: number; xStart: number; xEnd?: number },
  w: number, floorY: number, nowMs: number): boolean {
  // 比較版 (DEV ?purpleSwap) では部品の絵も 'unparry' の色へ写した写しで描く (元の bride_rose_atlas.png は触らない)。
  const img = atlas ? swapImage('unparry', atlas) : null
  if (!img) { preloadBrideRoseAtlas(); return false }
  const xEnd = hz.xEnd ?? hz.xStart + w
  const cl = roseClusterLayout(hz.xStart, xEnd)
  const delay = roseRiseDelayMs(hz.xStart, xEnd)
  const f = roseFrame(hz.elapsedMs, hz.telegraphMs, delay, nowMs)
  const riseStart = hz.telegraphMs - ROSE_RISE_MS - delay
  const fadeEnd = 1   // 当たりの間は消さない (しおれは当たりが終わってから・drawBrideRoseWithers)
  drawCrackGlow(ctx, cl, floorY, f.glow, f.peek)
  const sec = nowMs / 1000
  const sway = (c: RoseCane) => f.activeMs >= 0 ? ROSE_SWAY_RAD * Math.sin(sec * 2.6 + c.swayPhase) : 0
  // 予告：茎の先がのぞく (同じ茎を沈めて、先だけを床の上に出す)
  const peekLift = (c: RoseCane) => {
    const pk = ROSE_PEEK_H * (0.75 + 0.5 * ((c.swayPhase / 6.28) % 1)) * f.peek
    return Math.min(c.h, pk + f.tremble)
  }
  const lift = (c: RoseCane) => {
    if (hz.elapsedMs < riseStart) return peekLift(c)
    const base = ROSE_PEEK_H * 0.9
    return base + (c.h - base) * f.emerge
  }
  for (const c of cl.canes) drawCane(ctx, img, c, floorY, lift(c), fadeEnd, { sway: sway(c) })
  // 花：咲くまでは閉じたつぼみ
  const anchors: { x: number; y: number }[] = []
  for (const b of cl.blooms) {
    let an = bloomAnchor(cl, b, floorY, lift, sway)
    if (b.cane < 0) {
      // 床のつぼみ：細い茎の先。予告で床から出てくる
      const up = b.stalkH * (f.activeMs >= 0 ? 1 : f.peek)
      an = { x: b.x + (f.activeMs < 0 ? f.tremble * 0.6 : 0), y: floorY - up, rot: an.rot }
      drawStalk(ctx, b.x, floorY, an.x, an.y, b.size * 0.16)
    } else if (an.y > floorY - 4) {
      continue   // まだ床の下
    }
    anchors.push(an)
    const budW = b.size * 0.42
    if (f.bloom < 1) {
      drawPart(ctx, img, b.bud, an.x, an.y, budW * (1 - 0.3 * f.bloom), an.rot, 1 - f.bloom, 0.8)
    }
    if (f.bloom > 0) {
      const sc = 0.35 + 0.65 * riseEase(f.bloom)
      drawPart(ctx, img, b.rose, an.x, an.y, b.size * sc, an.rot * (1 - 0.4 * f.bloom), Math.min(1, f.bloom * 1.6), 0.6)
    }
  }
  drawShards(ctx, cl, floorY, hz.elapsedMs - riseStart - ROSE_RISE_MS * 0.5)
  if (f.activeMs >= 0) {
    drawPetals(ctx, img, cl, floorY, f.activeMs, anchors, 1)
    noteActive(cl, f.activeMs, anchors)
  }
  return true
}

/** 床のつぼみの細い茎 (暗い紫の塗り・線の効果ではない)。 */
function drawStalk(ctx: RoseCtx, x0: number, floorY: number, x1: number, y1: number, width: number): void {
  if (y1 >= floorY) return
  const wv = Math.max(1.4, width)
  ctx.save()
  ctx.fillStyle = `rgb(${swc('unparry', '42,24,56')})`
  ctx.beginPath()
  ctx.moveTo(x0 - wv, floorY + 2)
  ctx.quadraticCurveTo(x0 - wv * 0.8 + (x1 - x0) * 0.3, (floorY + y1) / 2, x1 - wv * 0.4, y1 + 2)
  ctx.lineTo(x1 + wv * 0.4, y1 + 2)
  ctx.quadraticCurveTo(x0 + wv * 0.8 + (x1 - x0) * 0.3, (floorY + y1) / 2, x0 + wv, floorY + 2)
  ctx.closePath()
  ctx.fill()
  ctx.fillStyle = `rgba(${swc('unparry', '154,122,196')},0.55)`
  ctx.beginPath()
  ctx.moveTo(x0 + wv * 0.3, floorY + 2)
  ctx.quadraticCurveTo(x0 + wv * 0.2 + (x1 - x0) * 0.3, (floorY + y1) / 2, x1 + wv * 0.1, y1 + 2)
  ctx.lineTo(x1 + wv * 0.4, y1 + 2)
  ctx.quadraticCurveTo(x0 + wv * 0.8 + (x1 - x0) * 0.3, (floorY + y1) / 2, x0 + wv, floorY + 2)
  ctx.closePath()
  ctx.fill()
  ctx.restore()
}

// ───────── しおれ (当たりが終わった後) ─────────
interface WitherEntry { cl: RoseCluster; startGameMs: number | null; lastPetalT: number; anchors: { x: number; y: number }[] }
const withers = new Map<string, WitherEntry>()
let lastGameMs = 0
function keyOf(cl: RoseCluster): string { return `${Math.round(cl.xStart)}|${Math.round(cl.xEnd)}` }
function noteActive(cl: RoseCluster, activeT: number, anchors: { x: number; y: number }[]): void {
  const k = keyOf(cl)
  const e = withers.get(k)
  if (!e || e.startGameMs !== null) withers.set(k, { cl, startGameMs: null, lastPetalT: activeT, anchors: anchors.slice() })
  else { e.lastPetalT = activeT; e.anchors = anchors.slice() }
}
/** テスト用。 */
export function resetBrideRoseWithersForTest(): void { withers.clear(); lastGameMs = 0 }
/** テスト用：いましおれ中の場所の数。 */
export function brideRoseWitherCount(): number { return withers.size }

/**
 * しおれて崩れる茨を描く。render.ts の drawHazards の頭で毎コマ呼ぶ (帯が消えた後も描くため)。
 *   帯がまだ残っている間は描かない (二重にならない)。時刻はゲームの時刻 (止めると止まる)。
 */
export function drawBrideRoseWithers(ctx: RoseCtx, hits: ReadonlyArray<{ kind?: string; xStart: number; xEnd: number }>,
  gameMs: number, floorY: number, bossX?: number | null): void {
  setBrideRoseBossX(bossX)
  if (motif !== 'rose') return
  if (gameMs < lastGameMs - 1) withers.clear()     // 戦い直し
  lastGameMs = gameMs
  if (withers.size === 0) return
  const img = atlas ? swapImage('unparry', atlas) : null   // 比較版 (DEV ?purpleSwap) の写し。既定は atlas そのもの
  for (const [k, e] of withers) {
    const alive = hits.some(h => h.kind === 'thorns' && `${Math.round(h.xStart)}|${Math.round(h.xEnd)}` === k)
    if (alive) continue
    if (e.startGameMs === null) e.startGameMs = gameMs
    const t = gameMs - e.startGameMs
    if (t > ROSE_WITHER_MS || !img) { withers.delete(k); continue }
    drawWither(ctx, img, e.cl, floorY, t, e.lastPetalT, e.anchors)
  }
}

function drawWither(ctx: RoseCtx, img: AtlasImage, cl: RoseCluster, floorY: number, t: number, activeT: number,
  activeAnchors: { x: number; y: number }[]): void {
  const k = t / ROSE_WITHER_MS
  const droop = 0.34 * easeInOut(k / 0.8)
  const sink = 0.6 * easeInCubic(k)
  const smax = 1 - 0.62 * easeInOut(k)
  const alpha = clamp01(1 - (k - 0.62) / 0.38)
  const gray = clamp01(t / 260)
  drawCrackGlow(ctx, cl, floorY, 0.3 * (1 - clamp01(t / 220)), 1 - k * 0.6)
  for (const c of cl.canes) {
    const opts = { smax, droop, sink: sink * c.h }
    drawCane(ctx, img, c, floorY, c.h, alpha, opts)
    if (atlasGray && gray > 0) drawCane(ctx, swapImage('unparry', atlasGray), c, floorY, c.h, alpha * gray, opts)
    drawAsh(ctx, cl, c, floorY, t, smax, droop, sink * c.h)
  }
  // 薔薇はしおれた花に変わって落ちる
  const anchors: { x: number; y: number }[] = []
  for (const b of cl.blooms) {
    const an = bloomAnchor(cl, b, floorY, c => c.h, () => 0, droop, b.cane < 0 ? 0 : sink * (cl.canes[b.cane]!.h))
    const fallT = Math.max(0, t - 90) / 1000
    const y = Math.min(floorY - b.size * 0.15, an.y + 0.5 * 520 * fallT * fallT)
    const x = an.x
    anchors.push({ x, y })
    const rot = an.rot + (b.cane < 0 ? 0.6 : 1.3) * easeInOut(k) * (b.side >= 0 ? 1 : -1)
    const sw = b.size * (1 - 0.25 * k)
    drawPart(ctx, img, b.rose, x, y, sw, rot, alpha * (1 - clamp01(t / 200)), 0.6)
    drawPart(ctx, img, 'wither_0', x, y, sw * 0.95, rot, alpha * clamp01(t / 200), 0.55)
  }
  // 当たりの間に散った花びらは床に残ったまま薄れる＋しおれで新しく散る
  drawPetals(ctx, img, cl, floorY, activeT + t, activeAnchors, alpha * 0.8)
  drawPetals(ctx, img, cl, floorY, t, anchors, alpha, 1)
}

/** 先から崩れる灰のかけら。 */
function drawAsh(ctx: RoseCtx, cl: RoseCluster, c: RoseCane, floorY: number, t: number, smax: number, droop: number, sink: number): void {
  const rnd = mulberry32((cl.seed ^ Math.round(c.rootX * 131)) >>> 0)
  const n = 9
  for (let j = 0; j < n; j++) {
    const born = (j / n) * ROSE_WITHER_MS * 0.8
    const age = (t - born) / 1000
    const vx = (rnd() - 0.5) * 40
    const size = 1.6 + rnd() * 2.2
    const spin = (rnd() - 0.5) * 10
    if (age < 0) continue
    const sBorn = 1 - 0.62 * easeInOut(born / ROSE_WITHER_MS)
    if (sBorn > smax + 0.2) continue
    const p = canePoint(c, sBorn, droop)
    let x = c.rootX + p.x + vx * age
    const y = Math.min(floorY, floorY + 4 + sink + p.y + 0.5 * 260 * age * age - 12 * age)
    x = Math.max(cl.xStart + 2, Math.min(cl.xEnd - 2, x))
    const a = clamp01(1 - age / 0.45)
    if (a <= 0) continue
    ctx.save()
    ctx.translate(x, y)
    ctx.rotate(spin * age)
    ctx.globalAlpha = a
    ctx.fillStyle = rgba(ROSE_COLORS.ash, 1)
    ctx.beginPath()
    ctx.moveTo(-size, 0); ctx.lineTo(0, -size * 0.7); ctx.lineTo(size, size * 0.2); ctx.lineTo(-size * 0.2, size * 0.6)
    ctx.closePath(); ctx.fill()
    ctx.restore()
  }
}

// URL の読み取りは最後 (上の let が初期化された後)。配布版はこの箱ごと消える = 常に rose。
if (import.meta.env.DEV && typeof window !== 'undefined') {
  motif = parseBrideThornMotif(new URLSearchParams(window.location.search).get('thornLook')) ?? 'rose'
}
// 部品の絵はブラウザで読み込みの時に先読みする (最初の花嫁戦で結晶に戻らないように)。node のテストでは window が無いので何もしない。
if (motif === 'rose' && typeof window !== 'undefined') preloadBrideRoseAtlas()
